<template>
    <Head title="Reset Password" />
    <body>
        <div id=login>
            <img
                src="/img/04_Subit_logo_B.png"
                alt="logo_menu"
                class="logo"
                style="width: 280px;"
            />
            <div id=login_box>
                <form action="" method="post" class="two_auth" onsubmit="return false;">
                    <dl>
                        <div class="lf_code">
                            <dt><label for="code">メールアドレス</label></dt>
                            <dd><jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus /></dd>
                        </div>
                        <div class="lf_code">
                            <dt><label for="code">パスワード</label></dt>
                            <dd><jet-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" /></dd>
                        </div>
                        <div class="lf_code">
                            <dt><label for="code">確認用パスワード</label></dt>
                            <dd><jet-input id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" /></dd>
                        </div>
                        <div class="lf_submit">
                            <input type="submit" value="パスワードをリセット" v-on:click="popuperror" id="sb" class="btn btn-purple">
                        </div>
                    </dl>
                </form>
            </div>
        </div>
    </body>
</template>

<style lang="css">
    *{
        padding:0;
        margin: 0;
    }
    /* html,body{
        overflow: hidden;
    } */
    body{
        background-image: url("/img/01_background_img.png");
        /* 画像を常に天地左右の中央に配置 */
        background-position: center center;
        /* 画像をタイル状に繰り返し表示しない */
        background-repeat: no-repeat;
        /* コンテンツの高さが画像の高さより大きい時、動かないように固定 */
        background-attachment: fixed;
        /* 表示するコンテナの大きさに基づいて、背景画像を調整 */
        background-size: cover;
        /* 背景画像が読み込まれる前に表示される背景のカラー */
        background-color: #464646;
    }
    .fp{
        text-align: center;
    }
    .fp a{
        opacity: 0.5;
        color: black;
    }
    input::placeholder {
        text-align: center;
    }
    #code{
        width: 280px;
    }
    #sb{
        width: 280px;
        /* font-weight: 700; */
        margin: 15px 0;
    }
    input {
        width: 280px;
    }
    .close_btn{
        float:right;
        margin:10px;
        width:70px;
    }
    .error_box{
        position: fixed;
        z-index: 10;
        width: 100%;
        height: 100%;
        background: rgba(1, 1, 1, 0.3);
    }
    .eb{
        border: solid black ;
        background: #FFFBF9;
        width:350px;
        height: 150px;
        position: absolute;
        top: 5%;
        left: 50%;
        transform: translate(-50%);
    }
    .eb p{
        margin: 0;
        padding:10px;
        font-size: small;
        font-weight: 300;
    }
    .error{
        background: #D20000;
        color: white;
    }
    .active{
        display: block;
    }
    .lf_rm{
        position: relative;
    }
    .lf_submit{
        float: right;
    }
    .logo{
        display: block;
        margin: 0 auto;
    }
    .body{
        /* background: white; */
        width: 100%;
        height: 100%;
        position: relative;
    }
    #login{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    #login_box{
        /* background: #A07ABE; */
        padding: 12px 10px 10px 10px;
        width:300px;
        height: 200px;
        /* border: solid black 1px; */
    }
</style>

<script>
    import { defineComponent } from 'vue';
    import { Head } from '@inertiajs/inertia-vue3';
    import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
    import axios from 'axios';

    export default defineComponent({
        components: {
            Head,
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetButton,
            JetInput,
            JetLabel,
            JetValidationErrors
        },

        props: {
            email: String,
            token: String,
        },

        data() {
            return {
                form: this.$inertia.form({
                    token: this.token,
                    email: this.email,
                    password: '',
                    password_confirmation: '',
                })
            }
        },

        methods: {
            popuperror() {
                let reg = /^[^@]+@[^@]+$/;
                let peg =/^(?=.*[A-Z])(?=.*[!-/:-@¥[-`{-~])[a-zA-Z0-9!-/:-@¥[-`{-~]{8,24}$/; //8-24文字かつ(大文字)(小文字)(数字)(記号)をそれぞれ最低1文字以上ずつ使用する
                if ( !reg.test(this.form.email) ) {
                    alert("メールアドレスの形式が正しくありません。入力し直してください");
                    return;
                }else if ( !peg.test(this.form.password) ) {
                    alert("パスワードは大文字、小文字,記号、数字を含む8文字以上24文字以下でお願いします。");
                    return;
                }

                if ( this.form.password !== this.form.password_confirmation) {
                    alert("パスワードと確認用パスワードが異なります。入力し直してください");
                    return;
                }

                axios.post(route('custom.password.update'),this.form)
                .then((res)=>{
                    alert(res.data.status);
                    location.href = route('login');
                }).catch((e)=>{
                    alert(e.response.data.email);
                })
            }
        }
    })
</script>
